export function createPipeId(registerNumber, groupName, keyNumber) {
    return `${groupName}-${leadingZero(registerNumber)}-${leadingZero(
        keyNumber
    )}`;
}

export function leadingZero(number) {
    if (number < 10) {
        return `0${number}`;
    }

    return `${number}`;
}
